import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [ok, setOk] = useState(false);

  function set(k, v) {
    setForm((f) => ({ ...f, [k]: v }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (submitting) return;
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please fill in every field.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      setOk(true);
      setForm({ name: "", email: "", message: "" });
      toast.success("Thanks — we'll be in touch shortly.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err));
    } finally {
      setSubmitting(false);
    }
  }

  if (ok) {
    return (
      <div
        className="hbe-card p-6 text-center"
        data-testid="contact-form-success"
      >
        <div className="font-serif text-2xl text-hbe-primary">
          Message received.
        </div>
        <p className="mt-2 text-sm text-hbe-ink/70">
          Someone from HBE will reach out to you shortly.
        </p>
        <button
          type="button"
          className="hbe-btn-ghost mt-5"
          onClick={() => setOk(false)}
          data-testid="contact-form-send-another"
        >
          Send another
        </button>
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      className="hbe-card p-6 md:p-8 space-y-4"
      data-testid="contact-form"
      noValidate
    >
      <div>
        <label className="hbe-label" htmlFor="cf-name">Full name</label>
        <input
          id="cf-name"
          type="text"
          className="hbe-input"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          data-testid="contact-form-name"
          required
        />
      </div>
      <div>
        <label className="hbe-label" htmlFor="cf-email">Email</label>
        <input
          id="cf-email"
          type="email"
          className="hbe-input"
          value={form.email}
          onChange={(e) => set("email", e.target.value)}
          data-testid="contact-form-email"
          required
        />
      </div>
      <div>
        <label className="hbe-label" htmlFor="cf-message">How can we help?</label>
        <textarea
          id="cf-message"
          rows={5}
          className="hbe-input resize-y"
          value={form.message}
          onChange={(e) => set("message", e.target.value)}
          data-testid="contact-form-message"
          required
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="hbe-btn-primary w-full md:w-auto"
        data-testid="contact-form-submit"
      >
        {submitting ? "Sending…" : "Send message"}
      </button>
    </form>
  );
}
